// extracted by mini-css-extract-plugin
export default {"container":"dk-z","disabled":"ek-z","subtotal":"fk-z","legal":"gk-z"};